
// npm
import {Map as ImmutableMap} from 'immutable'

// redux
import * as ACTION_TYPES from './action-types'
import * as EXAM_ACTION_TYPES from 'redux/reducers/exam/action-types'


const DEFAULT_DRAWING = {shapes: [], showGrid: false};

// the WORKINGS field is a plain string for orgs without the drawing/code features, but is
// repurposed as a JSON envelope ({notes, drawing, code}) for orgs with either enabled - fall
// back to treating the whole value as plain notes if it isn't that envelope, so exams/answers
// saved before these features existed keep working unchanged
const parseWorkingsEnvelope = (raw) => {
	if (!raw) {
		return {notes: '', drawing: DEFAULT_DRAWING, code: ''};
	}

	try {
		const parsed = JSON.parse(raw);
		if (parsed && typeof parsed === 'object' && 'notes' in parsed) {
			return {
				notes: parsed.notes || '',
				drawing: parsed.drawing || DEFAULT_DRAWING,
				code: parsed.code || ''
			};
		}
	} catch (e) {
		// not JSON - legacy plain-text workings
	}

	return {notes: raw, drawing: DEFAULT_DRAWING, code: ''};
};

const WORKINGS_REDUCER = (state=ImmutableMap(), action) =>
{
	switch (action.type)
	{
		case EXAM_ACTION_TYPES.SET_EXAM_DATA: {
			const {notes, drawing, code} = parseWorkingsEnvelope(action.data.WORKINGS);
			return state
				.set('value', notes)
				.set('drawing', drawing)
				.set('code', code)
				.set('imageId', action.data.WORKINGS_IMAGE_ID || undefined);
		}
		case ACTION_TYPES.CHANGE:
			return state.set('value', action.value);
		case ACTION_TYPES.CHANGE_DRAWING:
			return state.set('drawing', action.drawing);
		case ACTION_TYPES.SET_IMAGE_ID:
			return state.set('imageId', action.imageId);
		case ACTION_TYPES.CHANGE_CODE:
			return state.set('code', action.code);
		default:
			return state;
	}
}

export {WORKINGS_REDUCER}
